// src/components/ReceiptPrint.jsx
import React from 'react';
import './ReceiptPrint.css';
import ccjabLogo from '../images/logo.png';

// Fonction pour formater les dates en format lisible
const formatDateHeure = (isoString) => {
  if (!isoString) return 'N/A';
  try {
    const date = new Date(isoString);
    return date.toLocaleString('fr-FR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  } catch (e) {
    return isoString;
  }
};


const ReceiptPrint = ({ event }) => {
  if (!event) return null;

  const avance =
    Number(event.tranche_1 || 0) +
    Number(event.tranche_2 || 0) +
    Number(event.tranche_3 || 0);
  const reste = Number(event.total_payer || 0) - avance;

  return (
    <div id="recu-a-imprimer" style={{ padding: 25, fontFamily: 'Arial', fontSize: 13 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 20 }}>
        <img src={ccjabLogo} alt="logo" style={{ width: '100px' }} />
        <div style={{ fontSize: 14 }}>
          <strong>CENTRE CULTUREL JACQUES AKA DE BOUAKE (CCJAB)</strong>
          <br />
          SOUS-DIRECTION DE LA PRODUCTION,<br />
          <hr />
          DES SCIENCES DE L’INFORMATION DOCUMENTAIRE<br />
          ET DE L’ACTION CULTURELLE
        </div>
      </div>

      <h2 style={{ textAlign: 'center', marginTop: 30 }}>FACTURE</h2>

      <p>
        <b>Client :</b> {event.nom_prenom || 'Inconnu'}<br />
        <b>Contact :</b> {event.contact || 'N/A'}
      </p>

      <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }} border="1">
        <thead>
          <tr>
            <th style={{ padding: 6 }}>DESIGNATION</th>
            <th style={{ padding: 6 }}>SALLE(S)</th>
            <th style={{ padding: 6 }}>DATE / HEURE</th>
            <th style={{ padding: 6 }}>NET À PAYER</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={{ padding: 6 }}>{event.titre}</td>
            <td style={{ padding: 6 }}>{(event.noms_salles || []).join(', ')}</td>
            <td style={{ padding: 6, lineHeight: 1.5 }}>
              <div>Réservé le : {formatDateHeure(event.date_creation)}</div>
              <hr />
              <div>Débute : {formatDateHeure(event.debut_date)}</div>
              <hr />
              <div>Termine : {formatDateHeure(event.fin_date)}</div>
            </td>
            <td style={{ padding: 6 }}>{Number(event.total_payer).toLocaleString()} FCFA</td>
          </tr>
          <tr>
            <td colSpan="3" style={{ padding: 6 }}>Avance</td>
            <td style={{ padding: 6 }}>{avance.toLocaleString()} FCFA</td>
          </tr>
          <tr>
            <td colSpan="3" style={{ padding: 6 }}>Reste à payer</td>
            <td style={{ padding: 6 }}>{reste.toLocaleString()} FCFA</td>
          </tr>
        </tbody>
      </table>


      <p style={{ marginTop: 20 }}>
        <b>Arrêté la présente facture à la somme de :</b> {Number(event.total_payer).toLocaleString()} FCFA
      </p>
      <p style={{ fontSize: 12 }}>
        <b>NB :</b> Le montant versé n'est pas remboursable si l'activité est annulée, reportée ou ajournée.
      </p>
      <p style={{ textAlign: 'right' }}>
        <i>Fait à Bouaké, le {formatDateHeure(event.date_creation)}</i>
      </p>
      <p style={{ textAlign: 'right', marginTop: 50 }}>
        <b><u>Abou SEKONGO Abel</u></b>
      </p>
    </div>
  );
};

export default ReceiptPrint;